// extracted by mini-css-extract-plugin
module.exports = {"cell":"Cell_cell__fv93r","firstRow":"Cell_firstRow__2E9oE","lastColumn":"Cell_lastColumn__2WNNW","droppable":"Cell_droppable__1P9wT"};